export const hasAnyRequiredPermission = (userPermissions = [], requiredPermissions = []) => {
  if (!requiredPermissions.length) return true;
  return requiredPermissions.some((permission) => userPermissions.includes(permission));
};

export const hasAllowedRole = (role, allowedRoles = []) => {
  if (!allowedRoles.length) return true;
  const normalizedRole = (role || '').toLowerCase();
  return allowedRoles.map((item) => item.toLowerCase()).includes(normalizedRole);
};

export const ROLE_LABELS = {
  super_admin: 'SuperAdmin',
  admin: 'Administrador',
  encargado: 'Encargado',
  visualizador: 'Visualizador',
};

export const getRoleLabel = (role) => {
  if (!role) return 'Sin rol asignado';
  return ROLE_LABELS[role.toLowerCase()] || role;
};

export const PERSONAL_PERMISSIONS = [
  'personal.read',
  'personal.read_all',
  'personal.create',
  'personal.create_all',
  'personal.edit',
  'personal.edit_all',
  'personal.data.edit',
  'personal.data.edit_all',
  'personal.assignments.edit',
  'personal.assignments.edit_all',
];

export const PERSONAL_DATA_EDIT_PERMISSIONS = [
  'personal.edit',
  'personal.edit_all',
  'personal.data.edit',
  'personal.data.edit_all',
];
export const PERSONAL_ASSIGNMENT_EDIT_PERMISSIONS = [
  'personal.edit',
  'personal.edit_all',
  'personal.assignments.edit',
  'personal.assignments.edit_all',
];
export const PERSONAL_EDIT_PERMISSIONS = [
  ...PERSONAL_DATA_EDIT_PERMISSIONS,
  ...PERSONAL_ASSIGNMENT_EDIT_PERMISSIONS,
];
export const PERSONAL_PAGE_PERMISSIONS = ['personal.read', 'personal.read_all'];

export const CALENDAR_PERMISSIONS = [
  'calendars.read',
  'calendars.read_all',
  'calendars.write',
  'calendars.write_all',
  'calendars.delete',
  'calendars.delete_all',
];
export const CALENDAR_WRITE_PERMISSIONS = ['calendars.write', 'calendars.write_all'];
export const CALENDAR_DELETE_PERMISSIONS = ['calendars.delete', 'calendars.delete_all'];
export const CALENDAR_PAGE_PERMISSIONS = ['calendars.read', 'calendars.read_all'];

// 'stations.read' se omite a propósito: lo tiene el rol visualizador (solo consulta su estación
// desde el menú) y no debe ver Configuración. Las tarjetas de estaciones/áreas siguen
// apareciendo dentro de Configuración para quien la tenga habilitada por otro permiso.
export const CONFIGURATION_PERMISSIONS = [
  'stations.write',
  'users.read',
  'users.write',
  'licenses.read',
  'licenses.write',
  'workshifts.read',
  'workshifts.write',
  'workshifts.global.write',
  'workshifts.local.write',
  'planner_rules.write',
];

export const STATION_PERMISSIONS = ['stations.read', 'stations.read_all', 'stations.write'];
export const POSITION_PAGE_PERMISSIONS = ['stations.read', 'stations.read_all'];
export const REPORT_PERMISSIONS = ['reports.hours.read', 'reports.hours.read_all'];
export const USER_CONFIG_PERMISSIONS = ['users.read', 'users.write'];
export const LICENSE_CONFIG_PERMISSIONS = ['licenses.read', 'licenses.write'];
export const WORKSHIFT_GLOBAL_WRITE_PERMISSIONS = ['workshifts.write', 'workshifts.global.write'];
export const WORKSHIFT_LOCAL_WRITE_PERMISSIONS = ['workshifts.write', 'workshifts.local.write'];
export const PLANNER_RULES_WRITE_PERMISSIONS = ['workshifts.write', 'planner_rules.write'];
export const WORKSHIFT_CONFIG_PERMISSIONS = [
  'workshifts.read',
  ...WORKSHIFT_GLOBAL_WRITE_PERMISSIONS,
  ...WORKSHIFT_LOCAL_WRITE_PERMISSIONS,
];
export const GENERAL_CONFIG_PERMISSIONS = ['workshifts.read', ...PLANNER_RULES_WRITE_PERMISSIONS];
export const STATION_PAGE_PERMISSIONS = ['stations.read', 'stations.read_all'];
export const USER_CONFIG_PAGE_PERMISSIONS = ['users.read'];
export const LICENSE_CONFIG_PAGE_PERMISSIONS = ['licenses.read'];
export const WORKSHIFT_CONFIG_PAGE_PERMISSIONS = ['workshifts.read'];
// La dotación tiene sus propios permisos: no depende de estaciones, calendarios ni turnos.
export const STAFFING_PAGE_PERMISSIONS = ['staffing.read', 'staffing.read_all'];
export const STAFFING_WRITE_PERMISSIONS = ['staffing.write'];
export const GENERAL_CONFIG_PAGE_PERMISSIONS = ['workshifts.read'];
